/* eslint-disable react-refresh/only-export-components -- standard context pattern */
import { createContext, useContext } from 'react';

const ManifestContext = createContext<string>('');

export const ManifestProvider = ManifestContext.Provider;
export const useManifestId = () => useContext(ManifestContext);
